import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { DEPTS } from "@/nav";

const PAGES = DEPTS.flatMap((d) => d.items.map((it) => ({
  key: `${d.id}-${it.slug}`, to: `/${d.id}/${it.slug}`, label: it.slug === "dashboard" ? `${d.name} Dashboard` : it.label, dept: d.name,
})));

export const GlobalSearch = () => {
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const hits = useMemo(() => {
    const s = q.trim().toLowerCase();
    return s ? PAGES.filter((p) => `${p.label} ${p.dept}`.toLowerCase().includes(s)).slice(0, 8) : [];
  }, [q]);

  const go = (p) => {
    if (!p) return;
    nav(p.to);
    setQ("");
    setOpen(false);
  };

  return (
    <form className="relative w-full max-w-md" onSubmit={(e) => { e.preventDefault(); go(hits[0]); }} data-testid="global-search">
      <Search className="pointer-events-none absolute left-3 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-slate-400" />
      <input
        value={q}
        onChange={(e) => { setQ(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        placeholder="Search pages, modules, departments..."
        className="h-9 w-full rounded-full border border-slate-200 bg-slate-50 pl-9 pr-20 text-xs text-slate-800 outline-none transition-colors placeholder:text-slate-400 focus:border-sky-500 focus:bg-white focus:ring-2 focus:ring-sky-100"
        data-testid="global-search-input"
      />
      <button type="submit" className="absolute right-1 top-1 h-7 rounded-full bg-petrol-800 px-4 text-[11px] font-medium text-white transition-colors hover:bg-sky-700" data-testid="global-search-btn">Search</button>
      {open && q && (
        <ul className="absolute left-0 right-0 top-11 z-40 overflow-hidden rounded-xl border border-slate-200 bg-white py-1 shadow-xl" data-testid="global-search-results">
          {hits.map((p) => (
            <li key={p.key}>
              <button type="button" onMouseDown={() => go(p)} className="flex w-full items-center justify-between px-3 py-2 text-left text-xs hover:bg-sky-50" data-testid={`search-hit-${p.key}`}>
                <span className="font-medium text-slate-800">{p.label}</span>
                <span className="text-[10px] uppercase tracking-wider text-slate-400">{p.dept}</span>
              </button>
            </li>
          ))}
          {!hits.length && <li className="px-3 py-3 text-xs text-slate-500">No matching pages</li>}
        </ul>
      )}
    </form>
  );
};
